import React, { useState } from 'react';
import { RoundedButton } from '../../../../../elements';
import { vaultStore } from '../../store/VaultStore';
import {
  ModalWrapper,
  ModalContent,
  ModalBody,
  ModalFooter,
  InputLabel,
  InputWrapper,
  StyledInput,
  StyledTextArea,
} from './UploadModal.styled';
import { useStore } from '../../../../../hooks';

const UploadModal = ({ isOpen, onClose, onSubmit }) => {
  const { authStore } = useStore();
  const [vaultName, setVaultName] = useState('');
  const [description, setDescription] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = async () => {
    if (!vaultName.trim()) return;
    
    setIsSubmitting(true);
    const success = await vaultStore.createDocumentFolder(vaultName.trim(), description.trim(), authStore.userId);
    setIsSubmitting(false);
    
    if (success) {
      setVaultName('');
      setDescription('');
      onSubmit();
    }
  };

  return (
    <ModalWrapper>
      <ModalContent role="dialog">
        <ModalBody>
          <InputWrapper>
            <InputLabel>Vault Name</InputLabel>
            <StyledInput
              type="text"
              value={vaultName}
              onChange={(e) => setVaultName(e.target.value)}
              placeholder="Enter vault name"
              disabled={isSubmitting}
            />
          </InputWrapper>
          <InputWrapper>
            <InputLabel>Description (optional)</InputLabel>
            <StyledTextArea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Enter description"
              disabled={isSubmitting}
            />
          </InputWrapper>
        </ModalBody>
        <ModalFooter>
          <RoundedButton 
            kind="default" 
            outline 
            onClick={onClose}
            disabled={isSubmitting}
          >
            Cancel
          </RoundedButton>
          <RoundedButton 
            kind="blue" 
            onClick={handleSubmit}
            disabled={isSubmitting || !vaultName.trim()}
          >
            {isSubmitting ? 'Creating...' : 'Create'}
          </RoundedButton>
        </ModalFooter>
      </ModalContent>
    </ModalWrapper>
  );
};

export default UploadModal; 